const examScoreRegex = /^[0-9]{1,3}$/;

angular.module('capability-ng-global').constant('examScoreRegex', examScoreRegex);



// WEBPACK FOOTER //
// ./app/lib/global/patterns/exam_score_regex.ts